import React, { useContext, useEffect, useMemo } from "react";
import {
  Grid,
  Card,
  FormControl,
  TextField,
  MenuItem,
  FormHelperText,
  InputAdornment,
  CircularProgress,
  Button,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles } from "@material-ui/core/styles";
import { add, formatError } from "utils/MyFunctions";
import feedbackContext from "contexts/feedbackContext";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { cameroon, portsCamer } from "utils/constants";
import { notify, closeSnack } from "utils/MyFunctions";
import axios from "axios";
import userContext from "contexts/userContext";
import { formatMessage } from "utils/MyFunctions";
import { useIntl, FormattedMessage } from "react-intl";
export default function LivePreviewExample(props) {
  const intl = useIntl();
  const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));
  const [calls, setCalls] = React.useState(0);
  const requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Accept: "application/ld+json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    cache: "no-cache",
  };
  const MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
  const MONOLITH_API_URL = process.env.REACT_APP_MONOLITH_API_URL;
  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    feedbackContext,
  );
  const { role, setRole, locale } = useContext(userContext);
  const [valid, setValid] = React.useState(false);

  const [error, setError] = React.useState(false);
  const [helper, setHelper] = React.useState("");

  const [blError, setBLError] = React.useState(false);
  const [blHelper, setBLHelper] = React.useState("");
  const [similarBLs, setSimilarBLs] = React.useState([]);
  const [currencies, setCurrencies] = React.useState([
    { value: "USD", name: "US Dollar" },
  ]);
  const [data, setData] = React.useState([]);
  const [ports, setPorts] = React.useState([]);
  const [incoterms, setIncoterms] = React.useState([]);

  //CREATE MODES
  const [createMode, setCreateMode] = React.useState({
    transporteur: false,
    navire: true,
  });

  //AUTOCOMPLETE PARAMS

  const [openT, setOpenT] = React.useState(false);
  const [openTr, setOpenTr] = React.useState(false);
  const [openN, setOpenN] = React.useState(false);
  const [openP, setOpenP] = React.useState(false);
  const [openPT, setOpenPT] = React.useState(false);
  const [openV, setOpenV] = React.useState(false);
  const [openPE, setOpenPE] = React.useState(false);
  const [openPD, setOpenPD] = React.useState(false);

  const [selectedVessel, setSelectedVessel] = React.useState({});

  const [transporteurs, setTransporteurs] = React.useState([]);
  const [navires, setNavires] = React.useState([]);
  const [pays, setPays] = React.useState([]);
  const [ville, setVille] = React.useState([]);
  const [portE, setPortE] = React.useState([]);
  const [portD, setPortD] = React.useState([]);

  const [fetching, setFetching] = React.useState(false);

  const loadingT = openT && fetching;
  const loadingTr = openTr && fetching;
  const loadingN = openN && fetching;
  const loadingP = openP && fetching;
  const loadingPT = openPT && fetching;
  const loadingPE = openPE && fetching;
  const loadingPD = openPD && fetching;
  const loadingV = openV && fetching;
  //
  const [values, setValues] = React.useState({
    transporteur: "",
    connaissement: "",
    navire: "",
    numVoyage: "",
    dateEmbarquement: "",
    dateEstArrivee: "",
    paysOrigine: "",
    portEmbarquement: "",
    portDebarquement: "",
    incoterm: "",
    fret: "0",
    deviseFret: "USD",
    destinationFinale: "",
    assurance: "0",
    deviseAssurance: "USD",
    supp: "0",
    deviseSupp: "USD",
    baf: "0",
    deviseBaf: "USD",
    caf: "0",
    deviseCaf: "USD",
    thc: "0",
    deviseTHC: "USD",
    // paysTransit: "",
  });
  const [villesR, setVillesR] = React.useState([]);
  const debounceLoad = _.debounce(async (api, search, suffix, setter) => {
    let params = "";
    console.log("DEBOUNCING search :", search, " suffix : ", suffix);
    try {
      const response = await fetch(props.api + suffix + search, {
        method: "GET",
        redirect: "follow",
        headers: {
          Accept: "application/ld+json",
          "Accept-Language": locale,
          Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
        },
      });
      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];

      let options = [];
      for (let s of _shippers) {
        options.push(s);
      }
      setter(options);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  useEffect(() => {
    setFetching(false);
  }, [transporteurs]);

  useEffect(() => {
    if (!openT) {
      setTransporteurs([]);
    }
  }, [openT]);

  useEffect(() => {
    setFetching(false);
  }, [navires]);

  useEffect(() => {
    console.log("openN changed, openN : ", openN);
    if (!openN) {
      setNavires([]);
    }
  }, [openN]);
  useEffect(() => {
    console.log("ville changed, ville : ", ville);
  }, [ville]);

  useEffect(() => {
    setFetching(false);
  }, [pays]);

  useEffect(() => {
    if (!openP) {
      setPays([]);
    }
  }, [openP]);
  useEffect(() => {
    if (!openPT) {
      setPays([]);
    }
  }, [openPT]);

  useEffect(() => {
    setFetching(false);
  }, [portE]);

  useEffect(() => {
    if (!openPE) {
      setPortE([]);
    }
  }, [openPE]);

  useEffect(() => {
    if (!openV) {
      setVille([]);
    }
  }, [openV]);

  useEffect(() => {
    setFetching(false);
  }, [ville]);

  useEffect(() => {
    setFetching(false);
  }, [portD]);

  useEffect(() => {
    if (!openPD) {
      setPortD([]);
    }
  }, [openPD]);

  useEffect(() => {
    props.setCarrier(values.transporteur);
  }, [values.transporteur]);

  const [openTransporteur, toggleOpenTransporteur] = React.useState(false);

  const [openNavire, toggleOpenNavire] = React.useState(false);
  const [imocheck, setIMOCheck] = React.useState(false);
  const [blcheck, setBLCheck] = React.useState(false);

  const handleCloseTransporteur = () => {
    setDialogValueTP({
      nom: "",
      adresse: "",
      email: "",
      tel: "",
      ville: "",
      pays: "",
    });

    toggleOpenTransporteur(false);
  };

  const nextDay = (date) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  };

  useEffect(() => {
    console.log("PROPS(TRANSPORT USEF) ARE : ", props);
    let _villesR = [];
    //LOAD THE TOWNS FROM CAMEROON IF IMPORT
    if (props.sens !== "export") {
      fetch(
        props.api + "/api/towns?country.code=CM&itemsPerPage=50",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => result["hydra:member"])
        .then((result) => {
          for (let res of result) {
            _villesR.push({
              id: res["@id"],
              code: res.code,
              ville: res.name,
              pays: res.countryName,
              countryId: res.country,
            });
          }

          setVillesR(_villesR);
        });
    }
  }, []);

  const handleCloseNavire = () => {
    setDialogValueN({
      name: "",
      imo: "",
      mmsi: "",
      status: "",
    });

    toggleOpenNavire(false);
  };

  const [dialogValueTP, setDialogValueTP] = React.useState({
    nom: "",
    adresse: "",
    email: "",
    tel: "",
    ville: "",
    pays: "",
  });

  useEffect(() => {}, [dialogValueTP]);

  const [dialogValueT, setDialogValueT] = React.useState({
    nom: "",
    adresse: "",
    tel: "",
    pays: "",
  });

  const [dialogValueN, setDialogValueN] = React.useState({
    nom: "",
    imo: "",
    mmsi: "",
    status: "",
  });

  const handleSubmitTP = async (event) => {
    let _return = null;
    event.preventDefault();
    //TODO -- set all props to main json and update them here

    let _message = "Création du transporteur en cours...";
    setFeedback({ ...feedback, ["bdOpen"]: true });
    let sb = notify(
      _message,
      "info",
      "center",
      "bottom",
      false,
      enqueueSnackbar,
    );
    let _value = {};
    let _carrier = { ...dialogValueTP };

    _value.name = _carrier.nom;
    _value.email = _carrier.email;
    _value.phone = _carrier.tel;
    _value.address = _carrier.adresse;
    _value.country = _carrier.ville.country;
    _value.town = _carrier.ville["@id"];

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: MASTER_API_URL + "/api/carriers",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      },

      data: _value,
    };

    try {
      let resp = await axios.request(config);
      console.log("sucess!! response below :");
      setFeedback({ ...feedback, ["bdOpen"]: false });
      console.log(JSON.stringify(resp.data));
      closeSnackbar(sb);
      notify(
        "Transporteur ajouté avec succès",
        "success",
        "center",
        "bottom",
        true,
        enqueueSnackbar,
      );
      _return = resp.data;
    } catch (error) {
      console.log("error!! error below :");
      console.log(error);
      setFeedback({ ...feedback, ["bdOpen"]: false });
      closeSnackbar(sb);
      notify(
        formatError(error),
        "error",
        "center",
        "top",
        true,
        enqueueSnackbar,
      );
      // setLoading(false);
      // setOpen(false);
    }

    setValues({ ...values, transporteur: _return });
    handleCloseTransporteur();
  };

  const handleSubmitN = async (event) => {
    let _return = null;
    event.preventDefault();
    //TODO -- set all props to main json and update them here

    if (error) {
      setValues({ ...values, navire: selectedVessel });
      document.activeElement.blur();
    } else {
      let _message = formatMessage(
        intl,
        "create_besc_maritime_import_accordion_transport_notify_adding_vessel",
      );
      setFeedback({ ...feedback, ["bdOpen"]: true });
      let sb = notify(
        _message,
        "info",
        "center",
        "bottom",
        false,
        enqueueSnackbar,
      );
      let _value = {};
      let _vessel = { ...dialogValueN };

      _value.imo = _vessel.imo;
      _value.mmsi = _vessel.mmsi;
      _value.name = _vessel.name;
      _value.status = "submitted";

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: MASTER_API_URL + "/api/vessels",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
        },

        data: _value,
      };

      try {
        let resp = await axios.request(config);
        console.log("sucess!! response below :");
        setFeedback({ ...feedback, ["bdOpen"]: false });
        console.log(JSON.stringify(resp.data));
        closeSnackbar(sb);
        notify(
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_transport_notify_vessel_added",
          ),
          "success",
          "center",
          "bottom",
          true,
          enqueueSnackbar,
        );
        _return = resp.data;
      } catch (error) {
        console.log("error!! error below :");
        console.log(error);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnackbar(sb);
        notify(
          formatError(error),
          "error",
          "center",
          "top",
          true,
          enqueueSnackbar,
        );
        // setLoading(false);
        // setOpen(false);
      }

      setValues({ ...values, navire: _return });
    }
    setError(false);
    setHelper("");
    handleCloseNavire();
    setOpenN(false);
  };

  const handleAutoCompleteTP = (event, newValue) => {
    if (newValue && typeof newValue["nom"] === "string") {
      if (
        ["ro-ro", "conteneur"].includes(props.conditionnement) &&
        values.connaissement !== "" &&
        !!values.connaissement &&
        !props.isGroup &&
        newValue !== "" &&
        !!newValue
      ) {
        console.log(
          "calling DBL from autocomplete TP with existing, non null BL, and newValue",
        );
        debounceCheckBL(values.connaissement, newValue ? newValue.uuid : null);
      } else {
        setBLError(false);
        setBLHelper("");
      }
      setValues({ ...values, transporteur: newValue });
    } else if (newValue && newValue.inputValue) {
      setCreateMode({ ...createMode, ["transporteur"]: true });
      toggleOpenTransporteur(true);
      setDialogValueTP({
        nom: newValue.inputValue,
        adresse: "",
        email: "",
        tel: "",
        ville: "",
        pays: "",
      });
    } else {
      setCreateMode({ ...createMode, ["transporteur"]: false });
      if (
        ["ro-ro", "conteneur"].includes(props.conditionnement) &&
        values.connaissement !== "" &&
        !!values.connaissement &&
        !props.isGroup &&
        newValue !== "" &&
        !!newValue
      ) {
        console.log("calling DBL from non create mode autocomplete TP");
        debounceCheckBL(values.connaissement, newValue ? newValue.uuid : null);
      } else {
        setBLError(false);
        setBLHelper("");
      }
      setValues({ ...values, transporteur: newValue });
    }
  };

  const handleAutoCompleteN = (event, newValue) => {
    console.log("handleAutoCompleteN");
    if (newValue && typeof newValue["nom"] === "string") {
      setValues({ ...values, navire: newValue });
    } else if (newValue && newValue.inputValue) {
      setCreateMode({ ...createMode, ["navire"]: true });
      toggleOpenNavire(true);
      setDialogValueN({
        name: newValue.inputValue,
        imo: "",
        mmsi: "",
        status: "",
      });
    } else {
      setCreateMode({ ...createMode, ["navire"]: false });

      setValues({ ...values, navire: newValue });
    }
  };

  const handleAutoCompleteChange = (event, newValue) => {
    if (newValue && typeof newValue["name"] === "string") {
      setDialogValueTP({
        ...dialogValueTP,
        ["ville"]: newValue,
        ["pays"]: newValue.countryName,
      });
    } else {
      setDialogValueTP({ ...dialogValueTP, ["ville"]: "" });
    }
  };

  useEffect(() => {
    if (Object.keys(props.data).length > 0) {
      console.log("set transport end (CHILD)");
      console.log("data coming fromn parent (transporteur)");
      setValues((prev) => {
        const merged = { ...prev, ...props.data };
        const same = Object.keys(merged).every(
          (key) => merged[key] === prev[key],
        );
        return same ? prev : merged;
      });
    }
  }, [props.data]);

  useEffect(() => {
    if (props.sens?.toLowerCase() === "export") {
      setValues((prev) => {
        if (prev.paysOrigine === cameroon) return prev; // prevent unnecessary setState
        return { ...prev, paysOrigine: cameroon };
      });
    }
  }, [props.sens]);

  useEffect(() => {
    let _navires = [];
    let _countries = [];
    let _ports = [];

    let _currencies = [];
    let _incoterms = [];

    //VALIDATION LOGIC
    console.log("values changed(transport INITIAL), values : ", values);
    //required fields

    let form = document.getElementById("transport-form");
    let validity = values.length == 0 ? false : form.checkValidity();
    let not_req = ["paysOrigine"];
    if (props.sens.toLowerCase() === "transit") {
      not_req.push("incoterm");
    }
    let req_fields = Object.keys(values).filter(
      (v) => !["paysOrigine"].includes(v),
    );

    let vals = Object.keys(values).map((v) => values[v]);
    console.log("vals : ", vals);
    let single_check = vals.includes("");
    console.log(single_check);

    let _values = { ...values };
    if (props.sens === "export") {
      _values["paysOrigine"] = cameroon;
    }
    // setValues(_values);

    setValid(validity);
    props.setValidity(validity);
    if (validity) {
      props.sendCreateMode(createMode);

      props.sendTransport(_values);
    }

    //FETCH CURRENCIES
    fetch(props.api + "/api/currencies?itemsPerPage=20", requestOptions)
      .then((response) => response.json())
      .then((result) => result["hydra:member"])
      .then((result) => {
        console.log(result);
        for (let res of result) {
          _currencies.push({ value: res.code, name: res.name });
        }
        setCurrencies(_currencies);
      })

      .catch((error) => console.log("error", error));

    //FETCH INCOTERMS
    fetch(props.api + "/api/incoterms?itemsPerPage=20", requestOptions)
      .then((response) => response.json())
      .then((result) => result["hydra:member"])
      .then((result) => {
        for (let res of result) {
          _incoterms.push(res.name);
        }
        setIncoterms(_incoterms);
      })

      .catch((error) => console.log("error", error));
  }, []);

  const debounceCheckBL = useMemo(
    () =>
      _.debounce(async (bl, carrier) => {
        console.log(" bl: ", bl);
        console.log(" carrier: ", carrier);
        try {
          setBLCheck(true);
          const response = await fetch(
            MONOLITH_API_URL + "/api/bescs?referenceDocNumber=" + bl.trim(),
            requestOptions,
          );

          //await sleep(1e3); // For demo purposes.
          let _shippers = await response.json();
          _shippers = _shippers["hydra:member"];
          if (_shippers.length > 0) {
            //DUPLICATE LOGIC
            // console.log("found matches : ", _shippers);
            // console.log("carrier : ", carrier);
            // console.log("props.bescId : ", props.bescId);
            // console.log("el id : ", el.id);

            let _match = _shippers.filter(
              (el) =>
                (props.bescId == null || parseInt(props.bescId) !== el.id) &&
                el.referenceDocNumber.trim() === bl.trim(),
            );
            console.log("match is : ", _match);
            if (_match.length > 0) {
              setBLError(true);
              setBLHelper(
                formatMessage(
                  intl,
                  "create_besc_maritime_import_accordion_transport_helper_existing_bl",
                ),
              );
            } else {
              setBLError(false);
              setBLHelper("");
            }
          } else {
            setBLError(false);
            setBLHelper("");
          }
          setBLCheck(false);
        } catch {
          setBLCheck(false);
          (e) => {
            console.log("an error occured, details : ", e);
          };
        }
      }, 600),
    [],
  );

  const debounceCheckIMO = _.debounce(async (imo) => {
    try {
      const response = await fetch(
        props.api + "/api/vessels?imo=" + imo,
        requestOptions,
      );

      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];
      if (_shippers.length > 0) {
        setError(true);
        setDialogValueN({
          ...dialogValueN,
          nom: _shippers[0].name,
          imo: _shippers[0].imo,
          mmsi: _shippers[0].mmsi,
        });
        setHelper(
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_transport_helper_existing_imo",
          ) + _shippers[0].name,
        );
        setSelectedVessel(_shippers[0]);
      }
      setIMOCheck(false);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  useEffect(() => {
    if (!openT) {
      setTransporteurs([]);
    }
  }, [openT]);

  useEffect(() => {
    console.log("values changed(transport), values : ", values);
    //required fields

    validateValues();
  }, [values, blcheck]);

  useEffect(() => {
    if (props.sens?.toLowerCase() === "export") {
      const sendValues = { ...values, paysOrigine: cameroon };
      if (JSON.stringify(sendValues) !== JSON.stringify(props.data)) {
        props.sendTransport(sendValues);
        props.sendCreateMode(createMode);
      }
    }
  }, [values, createMode]);

  useEffect(() => {
    console.log("use effect values transporteur is : ", values.transporteur);
    if (
      ["ro-ro", "conteneur"].includes(props.conditionnement) &&
      values.connaissement !== "" &&
      !!values.connaissement &&
      values.transporteur !== "" &&
      !!values.transporteur &&
      !props.isGroup
    ) {
      console.log(
        "transporteur uuid : ",
        values.transporteur ? values.transporteur.uuid : null,
      );
      debounceCheckBL(
        values.connaissement,
        values.transporteur ? values.transporteur.uuid : null,
      );
    } else {
      console.log("ELSE, didnt call debounceCheckBL");
      setBLError(false);
      setBLHelper("");
    }
  }, [props.conditionnement]);

  useEffect(() => {
    console.log("CALLS TO VALIDATE VALUES : ", calls);
  }, [calls]);

  const validateValues = async () => {
    let form = document.getElementById("transport-form");
    setCalls(calls + 1);
    console.log("values(TRANSPORT) : ", values);
    let validity = values.connaissement && values.connaissement.length > 0;

    console.log("validity before : ", validity);
    let _values = { ...values };
    if (props.sens.toLowerCase() === "transit") {
      delete _values.incoterm;
    }

    let req_fields = Object.keys(_values).filter((v) => ![""].includes(v));
    req_fields.map((rf) => {
      let _eval = _values[rf] || typeof _values[rf] === "number";
      validity = validity && !!_eval;
    });
    console.log("blError is : ", blError);
    validity = validity && !blError && !blcheck;

    console.log("validity after all checks : ", validity);

    setValid(validity);
    props.setValidity(validity);
    if (validity && props.sens.toLowerCase() !== "export") {
      props.sendCreateMode(createMode);
      props.sendTransport(values);
    }
  };

  const filter = createFilterOptions();

  // const currencies = [
  //   {
  //     value: 'USD',
  //     label: '$'
  //   },
  //   {
  //     value: 'EUR',
  //     label: '€'
  //   },
  //   {
  //     value: 'BTC',
  //     label: '฿'
  //   },
  //   {
  //     value: 'JPY',
  //     label: '¥'
  //   },
  //   {
  //     value: 'XAF',
  //     label: 'XAF'
  //   }
  // ];

  const handleChange = (event) => {
    event.persist(event);

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    tabPanelRoot: {
      padding: 0,
    },
    panel: {
      width: "100%",
    },
    zeromargin: {
      margin: 0,
    },
    zeropadding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: 300,
    },
  }));

  const pavillonDB = [];

  const classes = useStyles();
  return (
    <>
      <Card className="p-4 mb-4">
        <form id="transport-form">
          {/* -------------------------------------- Contrat de transport ----------------------------------- */}
          <div>
            <Grid
              container
              direction="row"
              // justifyContent="center"
              alignItems="center"
              // alignContent="center"
              // alignSelf="center"
              spacing={1}
              xs={12}
            >
              {/* -------------------------------------- Transporteur----------------------------------- */}
              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="outlined-select-currency"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_bill_of_lading",
                    )}
                    variant="outlined"
                    name="connaissement"
                    value={values.connaissement}
                    error={blError}
                    onChange={(event) => {
                      console.log("on change");
                      handleChange(event);
                      if (
                        values.transporteur !== "" &&
                        event.target.value !== "" &&
                        !!values.transporteur &&
                        ["ro-ro", "conteneur"].includes(
                          props.conditionnement,
                        ) &&
                        !props.isGroup
                      ) {
                        console.log(
                          "IF, connaissement : ",
                          values.connaissement,
                        );
                        console.log("debouncing check bl");
                        debounceCheckBL(
                          event.target.value,
                          values.transporteur ? values.transporteur.uuid : null,
                        );
                      }
                    }}
                    InputProps={{
                      endAdornment: blcheck && (
                        <InputAdornment position="end">
                          <CircularProgress size={20} />
                        </InputAdornment>
                      ),
                      readOnly:
                        role.user && role.user.roles[0].name === "Modificateur",
                    }}
                  ></TextField>
                  <FormHelperText error>
                    {!blError ? null : blHelper}
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    id="outlined-select-currency"
                    select
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_incoterm",
                    )}
                    required={props.sens !== "transit"}
                    variant="outlined"
                    name="incoterm"
                    value={values.incoterm}
                    onChange={(event) => handleChange(event)}
                  >
                    {incoterms.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="standard-basic"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_fret",
                    )}
                    name="fret"
                    type="number"
                    value={values.fret}
                    inputProps={{
                      min: 0,
                      step: "any",
                      required: true,
                    }}
                    variant="outlined"
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="outlined-select-currency"
                    select
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_fret_currency",
                    )}
                    name="deviseFret"
                    value={values.deviseFret}
                    onChange={(event) => handleChange(event)}
                    variant="outlined"
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={8} md={8}>
                <FormControl
                  fullWidth
                  className={classes.zeromargin}
                  variant="outlined"
                >
                  <Autocomplete
                    size="small"
                    value={values.transporteur}
                    onChange={(event, newValue) =>
                      handleAutoCompleteTP(event, newValue)
                    }
                    open={openT}
                    onOpen={() => {
                      setOpenT(true);
                    }}
                    onClose={() => {
                      setOpenT(false);
                    }}
                    loading={loadingT}
                    loadingText={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_searching",
                    )}
                    filterOptions={(options, params) => {
                      if (!loadingT) {
                        const filtered = filter(options, params);

                        // // Suggest the creation of a new value
                        // if (
                        //   params.inputValue !== "" &&
                        //   filtered.length === 0 &&
                        //   !loadingT
                        // ) {
                        //   filtered.push({
                        //     inputValue: params.inputValue,
                        //     text: "Créer " + params.inputValue,
                        //   });
                        // }

                        return filtered;
                      } else {
                        return [];
                      }
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={transporteurs}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.text;
                      }
                      // Regular option

                      return option.name;
                    }}
                    // renderOption={(option) => option.imo}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        required
                        {...params}
                        label={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_transport_label_carrier",
                        )}
                        variant="outlined"
                        name="transporteur"
                        onChange={(event) => {
                          event.persist(event);

                          if (event.target.value.length > 2) {
                            if (!fetching) {
                              setFetching(true);
                            }

                            debounceLoad(
                              props.api,
                              event.target.value,
                              "/api/carriers?name=",
                              setTransporteurs,
                            );
                          }

                          // if (event.target.value.length > 2) {
                          //   setFetching(true);

                          // }
                        }}
                      />
                    )}
                  ></Autocomplete>
                  {/* <Dialog
                    V={openTransporteur}
                    onClose={handleCloseTransporteur}
                    aria-labelledby="form-dialog-title"
                  > */}
                  {/* <form onSubmit={handleSubmitTP}>
                      <DialogTitle id="form-dialog-title">
                      {formatMessage(intl,"create_besc_maritime_import_accordion_transport_dialog_add_vessel_title")}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                        {formatMessage(intl,"create_besc_maritime_import_accordion_transport_dialog_add_vessel_description")}
                        </DialogContentText>
                        <Grid container direction="row" spacing={1} xs={12}>
                          <Grid item fullwidth xs={12} sm={10} md={5}>
                            <TextField
                              fullWidth
                              autoFocus
                              variant="outlined"
                              value={dialogValueTP.nom}
                              onChange={(event) =>
                                setDialogValueTP({
                                  ...dialogValueTP,
                                  nom: event.target.value,
                                })
                              }
                              label={formatMessage(intl,"create_besc_maritime_import_accordion_files")}
                              type="text"
                            />
                          </Grid>

                          <Grid fullWidth item xs={12} sm={10} md={5}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              value={dialogValueTP.tel}
                              onChange={(event) =>
                                setDialogValueTP({
                                  ...dialogValueTP,
                                  tel: event.target.value,
                                })
                              }
                              label={formatMessage(intl,"create_besc_maritime_import_accordion_files")}
                              type="text"
                            />
                          </Grid>

                          <Grid fullWidth item xs={12} sm={10} md={5}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              value={dialogValueTP.email}
                              onChange={(event) =>
                                setDialogValueTP({
                                  ...dialogValueTP,
                                  email: event.target.value,
                                })
                              }
                              label={formatMessage(intl,"create_besc_maritime_import_accordion_files")}
                              type="text"
                            />
                          </Grid>

                          <Grid fullWidth item xs={12} sm={10} md={5}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              value={dialogValueTP.adresse}
                              onChange={(event) =>
                                setDialogValueTP({
                                  ...dialogValueTP,
                                  adresse: event.target.value,
                                })
                              }
                              label={formatMessage(intl,"create_besc_maritime_import_accordion_files")}
                              type="text"
                            />
                          </Grid>

                          <Grid item xs={12} sm={10} md={5}>
                            <Autocomplete
                              autoHighlight
                              fullWidth
                              openOnFocus
                              onChange={(event, newValue) =>
                                handleAutoCompleteChange(event, newValue)
                              }
                              filterOptions={(options, params) => {
                                const filtered = filter(options, params);

                                // Suggest the creation of a new value
                                // if (
                                //   params.inputValue !== "" &&
                                //   filtered.length === 0
                                // ) {
                                //   filtered.push({
                                //     inputValue: params.inputValue,
                                //     text: "Créer " + params.inputValue,
                                //   });
                                // }

                                return filtered;
                              }}
                              selectOnFocus
                              clearOnBlur
                              handleHomeEndKeys
                              id="free-solo-with-text-demo"
                              options={pays}
                              getOptionLabel={(option) => {
                                // Value selected with enter, right from the input
                                if (typeof option === "string") {
                                  return option;
                                }
                                // Add "xxx" option created dynamically
                                if (option.inputValue) {
                                  return option.text;
                                }
                                // Regular option

                                return option.name + ", " + option.countryName;
                              }}
                              // renderOption={(option) => option.imo}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  label={formatMessage(intl,"create_besc_maritime_import_accordion_files")}
                                  variant="outlined"
                                  onChange={(event) => {
                                    event.persist(event);
                                    if (event.target.value.length > 2) {
                                      if (!fetching) {
                                        setFetching(true);
                                      }

                                      debounceLoad(
                                        props.api,
                                        event.target.value,
                                        "/api/towns?name=",
                                        setPays
                                      );
                                    }

                                    // if (event.target.value.length > 2) {
                                    //   setFetching(true);

                                    // }
                                  }}
                                />
                              )}
                            ></Autocomplete>
                          </Grid>
                          <Grid fullWidth item xs={12} sm={10} md={5}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              readOnly
                              value={dialogValueTP.pays}
                              onChange={(event) =>
                                setDialogValueTP({
                                  ...dialogValueTP,
                                  pays: event.target.value,
                                })
                              }
                              label={formatMessage(intl,"create_besc_maritime_import_accordion_files")}
                              type="text"
                            />
                          </Grid>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={handleCloseTransporteur}
                          color="primary"
                        >
                          Cancel
                        </Button>
                        <Button type="submit" color="primary">
                          Ajouter
                        </Button>
                      </DialogActions>
                    </form>
                  </Dialog> */}
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="standard-basic"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_insurance",
                    )}
                    variant="outlined"
                    type="number"
                    name="assurance"
                    value={values.assurance}
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    inputProps={{
                      min: 0,
                      step: "any",
                      required: true,
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="outlined-select-currency"
                    select
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_insurance_currency",
                    )}
                    name="deviseAssurance"
                    value={values.deviseAssurance}
                    onChange={(event) => handleChange(event)}
                    variant="outlined"
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              {/* -------------------------------------- Navire----------------------------------- */}

              <Grid item xs={12} sm={8} md={4}>
                <FormControl
                  fullWidth
                  className={classes.zeromargin}
                  variant="outlined"
                >
                  <Autocomplete
                    autoHighlight
                    openOnFocus
                    size="small"
                    value={values.navire}
                    open={openN}
                    onOpen={() => {
                      setOpenN(true);
                    }}
                    onClose={() => {
                      setOpenN(false);
                    }}
                    loading={loadingN}
                    onChange={(event, newValue) =>
                      handleAutoCompleteN(event, newValue)
                    }
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      // Suggest the creation of a new value
                      if (params.inputValue !== "" && filtered.length === 0) {
                        filtered.push({
                          inputValue: params.inputValue,
                          text: "Créer " + params.inputValue,
                        });
                      }
                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={navires}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.text;
                      }
                      // Regular option

                      return option.name;
                    }}
                    // renderOption={(option) => option.imo}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        required
                        label={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_transport_label_vessel",
                        )}
                        name="navire"
                        variant="outlined"
                        onChange={(event) => {
                          if (event.target.value.length > 2) {
                            if (!fetching) {
                              setFetching(true);
                            }

                            debounceLoad(
                              props.api,
                              event.target.value,
                              "/api/vessels?name=",
                              setNavires,
                            );
                          }

                          // if (event.target.value.length > 2) {
                          //   setFetching(true);

                          // }
                        }}
                      />
                    )}
                  ></Autocomplete>
                  <Dialog
                    open={openNavire}
                    onClose={handleCloseNavire}
                    aria-labelledby="form-dialog-title"
                  >
                    <form onSubmit={handleSubmitN}>
                      <DialogTitle id="form-dialog-title">
                        {formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_transport_dialog_add_vessel_title",
                        )}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          {formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_dialog_add_vessel_description",
                          )}
                        </DialogContentText>
                        <Grid container direction="row" spacing={2} xs={12}>
                          <Grid item xs={12} sm={8} md={4}>
                            <TextField
                              variant="outlined"
                              size="small"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={dialogValueN.nom}
                              onChange={(event) =>
                                setDialogValueN({
                                  ...dialogValueN,
                                  nom: event.target.value,
                                })
                              }
                              label={formatMessage(
                                intl,
                                "create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_name",
                              )}
                              type="text"
                            />
                          </Grid>
                          <Grid item xs={12} sm={8} md={4}>
                            <TextField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              variant="outlined"
                              size="small"
                              value={dialogValueN.imo}
                              onChange={(event) => {
                                setDialogValueN({
                                  ...dialogValueN,
                                  imo: event.target.value,
                                });
                                if (event.target.value.length == 7) {
                                  setIMOCheck(true);
                                  debounceCheckIMO(event.target.value);
                                } else {
                                  setError(false);
                                }
                              }}
                              error={error}
                              InputProps={{
                                endAdornment: imocheck && (
                                  <InputAdornment position="end">
                                    <CircularProgress size={20} />
                                  </InputAdornment>
                                ),
                              }}
                              label={formatMessage(
                                intl,
                                "create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_imo",
                              )}
                              type="text"
                            />
                          </Grid>
                          <Grid item xs={12} sm={8} md={4}>
                            <TextField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              variant="outlined"
                              size="small"
                              value={dialogValueN.mmsi}
                              onChange={(event) =>
                                setDialogValueN({
                                  ...dialogValueN,
                                  mmsi: event.target.value,
                                })
                              }
                              label={formatMessage(
                                intl,
                                "create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_mmsi",
                              )}
                              type="text"
                            />
                          </Grid>
                          <FormHelperText error>
                            {!error ? null : helper}
                          </FormHelperText>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleCloseNavire} color="primary">
                          {formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_cancel",
                          )}
                        </Button>
                        <Button type="submit" color="primary">
                          {error
                            ? formatMessage(
                                intl,
                                "create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_choose",
                              )
                            : formatMessage(
                                intl,
                                "create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_submit",
                              )}
                        </Button>
                      </DialogActions>
                    </form>
                  </Dialog>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="outlined-select-currency"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_voyage",
                    )}
                    variant="outlined"
                    name="numVoyage"
                    value={values.numVoyage}
                    onChange={(event) => handleChange(event)}
                  ></TextField>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="standard-basic"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_suppl",
                    )}
                    name="supp"
                    type="number"
                    inputProps={{
                      min: 0,
                      step: "any",
                      required: true,
                    }}
                    value={values.supp}
                    variant="outlined"
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="outlined-select-currency"
                    select
                    value={values.deviseSupp}
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_suppl_currency",
                    )}
                    name="deviseSupp"
                    onChange={(event) => handleChange(event)}
                    variant="outlined"
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="outlined-select-currency"
                    name="dateEmbarquement"
                    value={values.dateEmbarquement}
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_date_emb",
                    )}
                    type="date"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    variant="outlined"
                    InputProps={{
                      readOnly:
                        role.user && role.user.roles[0].name === "Modificateur",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(event) => {
                      handleChange(event);
                    }}
                  ></TextField>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="outlined-select-currency"
                    name="dateEstArrivee"
                    value={values.dateEstArrivee}
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_eta",
                    )}
                    type="date"
                    InputProps={
                      values.dateEmbarquement
                        ? {
                            readOnly:
                              role.user &&
                              role.user.roles[0].name === "Modificateur",
                            inputProps: {
                              min: nextDay(values.dateEmbarquement)
                                .toISOString()
                                .split("T")[0],
                            },
                          }
                        : {
                            readOnly:
                              role.user &&
                              role.user.roles[0].name === "Modificateur",
                          }
                    }
                    defaultValue={new Date().toISOString().split("T")[0]}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(event) => handleChange(event)}
                  ></TextField>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    id="standard-basic"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_baf",
                    )}
                    required
                    name="baf"
                    inputProps={{
                      min: 0,
                      step: "any",
                      required: true,
                    }}
                    value={values.baf}
                    variant="outlined"
                    type="number"
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    id="outlined-select-currency"
                    select
                    required
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_baf_currency",
                    )}
                    name="deviseBaf"
                    value={values.deviseBaf}
                    onChange={(event) => handleChange(event)}
                    variant="outlined"
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <Autocomplete
                    size="small"
                    name="paysOrigine"
                    value={values.paysOrigine}
                    open={openP}
                    onOpen={() => {
                      setOpenP(true);
                    }}
                    onClose={() => {
                      setOpenP(false);
                    }}
                    loading={loadingP}
                    onChange={(event, newValue) =>
                      setValues({ ...values, ["paysOrigine"]: newValue })
                    }
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      // Suggest the creation of a new value
                      // if (params.inputValue !== "" && filtered.length === 0) {
                      //   filtered.push({
                      //     inputValue: params.inputValue,
                      //     text: "Créer " + params.inputValue,
                      //   });
                      // }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={pays}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.text;
                      }
                      // Regular option

                      return option.name;
                    }}
                    // renderOption={(option) => option.imo}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        label={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_transport_label_country_origin",
                        )}
                        variant="outlined"
                        name="paysOrigine"
                        required
                        InputProps={{
                          ...params.InputProps,
                          readOnly: props.sens === "export",
                        }}
                        onChange={(event) => {
                          event.persist(event);
                          if (event.target.value.length > 2) {
                            if (!fetching) {
                              setFetching(true);
                            }

                            debounceLoad(
                              props.api,
                              event.target.value,
                              "/api/countries?translations.name=",
                              setPays,
                            );
                          }

                          // if (event.target.value.length > 2) {
                          //   setFetching(true);

                          // }
                        }}
                      />
                    )}
                  ></Autocomplete>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <Autocomplete
                    autoHighlight
                    size="small"
                    name="portEmbarquement"
                    value={values.portEmbarquement}
                    openOnFocus
                    onChange={(event, newValue) =>
                      setValues({ ...values, ["portEmbarquement"]: newValue })
                    }
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      // Suggest the creation of a new value
                      // if (params.inputValue !== "" && filtered.length === 0) {
                      //   filtered.push({
                      //     inputValue: params.inputValue,
                      //     text: "Créer " + params.inputValue,
                      //   });
                      // }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={
                      ["import", "regule", "transit"].includes(props.sens)
                        ? portE
                        : portsCamer
                    }
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.text;
                      }
                      // Regular option

                      return option.name + ", " + option.countryName;
                    }}
                    // renderOption={(option) => option.imo}
                    renderInput={(params) =>
                      role.user &&
                      role.user.roles[0].name === "Modificateur" ? (
                        <TextField
                          fullWidth
                          {...params}
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_label_port_emb",
                          )}
                          required
                          name="portEmbarquement"
                          variant="outlined"
                          InputProps={{ readOnly: true }}
                          onChange={(event) => {
                            event.persist(event);

                            if (
                              ["import", "regule", "transit"].includes(
                                props.sens,
                              ) &&
                              event.target.value.length > 2
                            ) {
                              if (!fetching) {
                                setFetching(true);
                              }

                              debounceLoad(
                                props.api,
                                event.target.value,
                                "/api/town_functions?name=",
                                setPortE,
                              );
                            }

                            // if (event.target.value.length > 2) {
                            //   setFetching(true);

                            // }
                          }}
                        />
                      ) : (
                        <TextField
                          fullWidth
                          {...params}
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_label_port_emb",
                          )}
                          required
                          name="portEmbarquement"
                          variant="outlined"
                          onChange={(event) => {
                            event.persist(event);

                            if (
                              ["import", "regule", "transit"].includes(
                                props.sens,
                              ) &&
                              event.target.value.length > 2
                            ) {
                              if (!fetching) {
                                setFetching(true);
                              }

                              debounceLoad(
                                props.api,
                                event.target.value,
                                "/api/town_functions?name=",
                                setPortE,
                              );
                            }

                            // if (event.target.value.length > 2) {
                            //   setFetching(true);

                            // }
                          }}
                        />
                      )
                    }
                  ></Autocomplete>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    id="standard-basic"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_caf",
                    )}
                    name="caf"
                    inputProps={{
                      min: 0,
                      step: "any",
                      required: true,
                    }}
                    type="number"
                    required
                    value={values.caf}
                    variant="outlined"
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    id="outlined-select-currency"
                    select
                    required
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_caf_currency",
                    )}
                    name="deviseCaf"
                    value={values.deviseCaf}
                    onChange={(event) => handleChange(event)}
                    variant="outlined"
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              {/* <Grid item xs={4} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined">
                  <TextField
                    className="m-2"
                    size="small"
                    id="outlined-select-currency"
                    select
                    name="modePaiement"
                    value={values.modePaiement}
                    label="Mode de paiement du frêt"
                    variant="outlined"
                    onChange={(event) => handleChange(event)}>
                    {paymodesDB.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid> */}

              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <Autocomplete
                    autoHighlight
                    size="small"
                    openOnFocus
                    name="portDebarquement"
                    value={values.portDebarquement}
                    onChange={(event, newValue) =>
                      setValues({ ...values, ["portDebarquement"]: newValue })
                    }
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      // Suggest the creation of a new value
                      // if (params.inputValue !== "" && filtered.length === 0) {
                      //   filtered.push({
                      //     inputValue: params.inputValue,
                      //     text: "Créer " + params.inputValue,
                      //   });
                      // }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={
                      ["export", "transit"].includes(props.sens)
                        ? portD
                        : portsCamer
                    }
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.text;
                      }
                      // Regular option

                      return option.name + ", " + option.countryName;
                    }}
                    // renderOption={(option) => option.imo}
                    renderInput={(params) =>
                      role.user &&
                      role.user.roles[0].name === "Modificateur" ? (
                        <TextField
                          fullWidth
                          {...params}
                          required
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_label_port_deb",
                          )}
                          name="portDebarquement"
                          variant="outlined"
                          InputProps={{ readOnly: true }}
                          onChange={(event) => {
                            event.persist(event);
                            console.log("sens : ", props.sens);

                            if (
                              ["export", "transit"].includes(props.sens) &&
                              event.target.value.length > 2
                            ) {
                              if (!fetching) {
                                setFetching(true);
                              }
                              debounceLoad(
                                props.api,
                                event.target.value,
                                "/api/town_functions?name=",
                                setPortD,
                              );
                            }

                            // if (event.target.value.length > 2) {
                            //   setFetching(true);

                            // }
                          }}
                        />
                      ) : (
                        <TextField
                          fullWidth
                          {...params}
                          required
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_label_port_deb",
                          )}
                          name="portDebarquement"
                          variant="outlined"
                          onChange={(event) => {
                            event.persist(event);

                            if (
                              ["export", "transit"].includes(props.sens) &&
                              event.target.value.length > 2
                            ) {
                              if (!fetching) {
                                setFetching(true);
                              }
                              debounceLoad(
                                props.api,
                                event.target.value,
                                "/api/town_functions?name=",
                                setPortD,
                              );
                            }

                            // if (event.target.value.length > 2) {
                            //   setFetching(true);

                            // }
                          }}
                        />
                      )
                    }
                  ></Autocomplete>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <Autocomplete
                    autoHighlight
                    size="small"
                    openOnFocus
                    open={openV}
                    onOpen={() => {
                      setOpenV(true);
                    }}
                    onClose={() => {
                      setOpenV(false);
                    }}
                    name="destinationFinale"
                    value={values.destinationFinale}
                    onChange={(event, newValue) =>
                      setValues({ ...values, ["destinationFinale"]: newValue })
                    }
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      // Suggest the creation of a new value
                      // if (params.inputValue !== "" && filtered.length === 0) {
                      //   filtered.push({
                      //     inputValue: params.inputValue,
                      //     text: "Créer " + params.inputValue,
                      //   });
                      // }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    loading={loadingV}
                    loadingText={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_searching",
                    )}
                    id="free-solo-with-text-demo"
                    options={
                      ["export", "transit"].includes(props.sens)
                        ? ville
                        : villesR
                    }
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.text;
                      }
                      // Regular option

                      return option.ville + ", " + option.pays;
                    }}
                    // renderOption={(option) => option.imo}
                    renderInput={(params) =>
                      role.user &&
                      role.user.roles[0].name === "Modificateur" ? (
                        <TextField
                          fullWidth
                          {...params}
                          required
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_label_final_dest",
                          )}
                          name="destinationFinale"
                          variant="outlined"
                          // InputProps={{ readOnly: true }}
                          onChange={(event) => {
                            // event.persist(event);
                            // if (
                            //   props.sens === "export" &&
                            //   event.target.value.length > 2
                            // ) {
                            //   if (!fetching) {
                            //     setFetching(true);
                            //   }
                            //   debounceLoad(
                            //     props.api,
                            //     event.target.value,
                            //     "/api/town_functions?name=",
                            //     setVille
                            //   );
                            // }
                            // if (event.target.value.length > 2) {
                            //   setFetching(true);
                            // }
                          }}
                        />
                      ) : (
                        <TextField
                          fullWidth
                          {...params}
                          required={props.sens !== "export"}
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_label_final_dest",
                          )}
                          name="destinationFinale"
                          variant="outlined"
                          onChange={(event) => {
                            event.persist(event);

                            if (
                              ["export", "transit"].includes(props.sens) &&
                              event.target.value.length > 2
                            ) {
                              if (!fetching) {
                                setFetching(true);
                              }
                              debounceLoad(
                                props.api,
                                event.target.value,
                                "/api/towns?name=",
                                (options) => {
                                  let _options = [...options];
                                  console.log("options before is ; ", options);
                                  for (let _option of _options) {
                                    _option.ville = _option.name;
                                    _option.pays = _option.countryName;
                                  }
                                  console.log("option after is ; ", options);
                                  setVille(_options);
                                },
                              );
                            }

                            // if (event.target.value.length > 2) {
                            //   setFetching(true);

                            // }
                          }}
                        />
                      )
                    }
                  ></Autocomplete>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    required
                    id="standard-basic"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_thc",
                    )}
                    variant="outlined"
                    inputProps={{
                      min: 0,
                      step: "any",
                      required: true,
                    }}
                    type="number"
                    name="thc"
                    value={values.thc}
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2} className={classes.zeromargin}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    size="small"
                    id="outlined-select-currency"
                    select
                    required
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_transport_label_thc_currency",
                    )}
                    name="deviseTHC"
                    value={values.deviseTHC}
                    onChange={(event) => handleChange(event)}
                    variant="outlined"
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              {/* {props.sens.toLowerCase() === "transit" && (
                <Grid item xs={12} sm={8} md={4} className={classes.zeromargin}>
                  <FormControl
                    fullWidth
                    className={classes.margin}
                    variant="outlined"
                  >
                    <Autocomplete
                      size="small"
                      name="paysTransit"
                      value={values.paysTransit}
                      open={openPT}
                      onOpen={() => {
                        setOpenPT(true);
                      }}
                      onClose={() => {
                        setOpenPT(false);
                      }}
                      loading={loadingPT}
                      onChange={(event, newValue) =>
                        setValues({ ...values, ["paysTransit"]: newValue })
                      }
                      filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        // Suggest the creation of a new value
                        // if (params.inputValue !== "" && filtered.length === 0) {
                        //   filtered.push({
                        //     inputValue: params.inputValue,
                        //     text: "Créer " + params.inputValue,
                        //   });
                        // }

                        return filtered;
                      }}
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      id="free-solo-with-text-demo"
                      options={pays}
                      getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === "string") {
                          return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                          return option.text;
                        }
                        // Regular option

                        return option.name;
                      }}
                      // renderOption={(option) => option.imo}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          {...params}
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_transport_label_country_transit",
                          )}
                          variant="outlined"
                          name="paysTransit"
                          required
                          onChange={(event) => {
                            event.persist(event);
                            if (event.target.value.length > 2) {
                              if (!fetching) {
                                setFetching(true);
                              }

                              debounceLoad(
                                props.api,
                                event.target.value,
                                "/api/countries?translations.name=",
                                setPays,
                              );
                            }

                            // if (event.target.value.length > 2) {
                            //   setFetching(true);

                            // }
                          }}
                        />
                      )}
                    ></Autocomplete>
                  </FormControl>
                </Grid>
              )} */}
            </Grid>
          </div>
        </form>
      </Card>
    </>
  );
}
